import { TranslationService } from '@/utils/services/TranslationService';

import useTranslation from '@/utils/hooks/translation/useTranslation';

import { LAYOUT_ANALYTICS_TYPES } from '@/lib/analytics/global';
import { MentionsConfig } from '@/lib/listening/pages/mentions';
import { ANALYZE_MENTIONS } from '@/lib/routes/privateRoutes';

import { LayoutAnalytics } from '@/components/layouts/wrappers/LayoutAnalytics';
import { WrapperSwitchLayout } from '@/components/layouts/wrappers/WrapperSwitchLayout';

const Mentions = () => {
    const { t: tCommons } = useTranslation('commons');

    return (
        <WrapperSwitchLayout>
            <LayoutAnalytics
                profileConfig={MentionsConfig}
                type={LAYOUT_ANALYTICS_TYPES.MENTIONS}
                title={tCommons('menu.mentions')}
            />
        </WrapperSwitchLayout>
    );
};

export const getStaticProps = TranslationService.getTranslationMessagesFromRoute(ANALYZE_MENTIONS);

export default Mentions;
